import React from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/Faqs.css'

//mui components
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import faq_question from '../assests/images/faq_question.png';

import LocalPhoneIcon from '@mui/icons-material/LocalPhone';


const Faqs = () => {

    let arr = [
        {
            heading: "Is it possible to make an online cab reservation?",
            desc: "You only need to complete the request form, and our customer service representative will arrange for a cab to pick you up as soon as the confirmation is received."
        },
        {
            heading: "What can I do if I forget or lose something in the Metro 24 x 7's taxi?",
            desc: "The best way to get in touch with us if you lose something in one of our cabs is to call us. Let us know the date and location of your trip, as well as the name of your driver, if possible. Your driver will be notified by phone. We'll figure out how to get it back to you if he finds it."
        },
        {
            heading: "What is your cancellation policy?",
            desc: "Refund requests must be made at least 7 days before the original reservation date. Only the original credit/debit card can receive a refund."
        },
        {
            heading: "How much do you charge?",
            desc: `"How do you charge for your cabs?" is a question with no single response. Kilometres are a factor because we cover a large area. If you have any questions, don't hesitate to get in touch with one of our representatives.`
        },
        {
            heading: "How can I recognise your cab?",
            desc: "The Metro 24 x 7 logo is displayed on the driver's door of our taxis. Upon arrival, the driver will also verify your name through the software."
        },
        {
            heading: "I am handicapped; what should I do?",
            desc: "Wheelchair-accessible vehicles are available in a variety of sizes and models. Just let Metro 24 x 7's representative know what you need when you make your reservation."
        }
    ];

    return (
        <div className='faqs'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>FAQ's</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='faq_content'>
                <div className='container '>
                    <div className='row my-5'>

                        <div className='col-lg-9 my-5'>
                            {
                                arr.map((item, index) => {
                                    return (
                                        <Accordion key={index} className='mb-5 pos-rel bg-gr-acc border-0'>
                                            <AccordionSummary

                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <div className='acrd_bef'>
                                                    <p className='py-1 px-3 f-14 f-pop-reg '>
                                                        {item.heading}
                                                    </p>
                                                </div>
                                                {/* <Typography>Accordion 1</Typography> */}
                                            </AccordionSummary>

                                            <div className='acc_details'>
                                                <div className='bef_acc_cont'></div>
                                                <div className='f-pop-med f-12 clr-77 lh-02 ps-3 brdr-lft-fqs'>
                                                    {item.desc}
                                                </div>
                                            </div>
                                        </Accordion>
                                    )
                                })
                            }
                        </div>


                        <div className='col-lg-3 my-5'>
                            <div className='card border-0 bg-f9 rounded'>
                                <div className='card-body pt-5 pb-3 px-1 '>
                                    <div className='container-fluid'>
                                        <div className='row'>
                                            <div className='col-lg-12 text-center mb-2'>
                                                <img src={faq_question} alt="faq question mark" />
                                                <p className='clr-1c f-pop-med f-20 mt-4'>Do You need Support</p>
                                                <p className='f-12 f-pop-med mt-3 lh-02 mb-2'>Our support agents are available 24/7. Call us now</p>
                                                <div className='brdr-gr-support my-4 mx-4'>

                                                </div>
                                                <LocalPhoneIcon className='clr-1c f-pop-med f-ico-phone mt-1 mb-2' />
                                                <p className='clr-1c f-pop-med f-20'>Available 24x7</p>
                                                <p className='f-pop-reg f-20 my-2'>Toll-Free: 123 456 7890</p>
                                                <p className='f-pop-reg f-20'>Toll-Free: 123 456 7890</p>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
};

export default Faqs;